import borderColor from './border-color';
import errorMessageColor from './error-message';

export default {
  borderColor,
  errorMessageColor,
};
